import { render, staticRenderFns } from "./QuizFront.vue?vue&type=template&id=1a79d3de&scoped=true&"
import script from "./QuizFront.vue?vue&type=script&lang=js&"
export * from "./QuizFront.vue?vue&type=script&lang=js&"
import style0 from "./QuizFront.vue?vue&type=style&index=0&id=1a79d3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79d3de",
  null
  
)

export default component.exports